import tippy from 'tippy.js';

import './tooltips.scss';

tippy.setDefaults({
  arrow: true,
  theme: "dark"
})

$(() => {
  tippy('.hover-tooltip')
});
